import '../vendor/bootstrap/css/bootstrap.min.css';
import '../css/sb-admin.min.css';
import '../css/morris.css';
import '../vendor/font-awesome/css/font-awesome.min.css';

import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import axios from 'axios';

// import config from '../../config.json';

import AdminIndex from './AdminIndex';
import AdminLogin from './AdminLogin';
import AdminControlPanel from './AdminControlPanel';

class AdminApp extends Component {
	handleLogout = () => {
		if (process.env.REACT_APP_FRONT_END === "true") {
			return;
		}
		axios.get('/api/auth/logout')
		.then((res) => {
			this.setState({user: {authenticated: false}});
			this.props.history.push('/admin/login');
		})
		.catch((err) => {

		});
	};

	constructor(props) {
		super(props);

		this.state = {
			user: {
				authenticated: false,
				provider: null,
				displayName: null,
				givenName: null,
				familyName: null,
				email: null,
				lastLogin: null,
				photos: null
			},
		}
	}

	get = () => {
		// concurrent api calls
		axios.all(
			[
				'/api/auth/user'
				// '/api/customer-forms/list'
				// '/api/home-container'
			]
			.map((x) => {return axios.get(x);}))
		.then(axios.spread((resUser) => {
			if (resUser) {
				this.setState({
					user: {
						authenticated: resUser.data.authenticated,
						provider: resUser.data.provider,
						displayName: resUser.data.displayName,
						givenName: resUser.data.givenName,
						familyName: resUser.data.familyName,
						email: resUser.data.email,
						lastLogin: resUser.data.lastLogin,
						photos: resUser.data.photos
					}
				});
			}
		}));
	};

	componentDidMount() {
		if (process.env.REACT_APP_FRONT_END === "true") {
			this.setState({
				user: {
					authenticated: true,
					displayName: "Front End User",
					givenName: "FirstName",
					familyName: "LastName",
					email: "example@gmail.com",
					lastLogin: "<null>",
					photos: [{ value: "#" }]
				}
			});
			return;
		}
		this.get();
	}

	// shouldComponentUpdate() {
	// 	// do not re-render (and reset the state) if user is logged in
	// 	return (!this.state.user.authenticated) ? false : true;
	// }

	render() {
		return (
			<Switch>
				<Route exact path="/admin" render={props =>
					<AdminIndex isAuthenticated={this.state.user.authenticated} {...props} />
				} />
				<Route exact path="/admin/login" render={props => 
					<AdminLogin isAuthenticated={this.state.user.authenticated} {...props} />
				} />
				{this.state.user.authenticated ? (
					<Route path="/admin/cp" render={props => 
						<AdminControlPanel
							handleLogout={this.handleLogout}
							getUser={this.getUser}
							user={this.state.user}
						{...props} />
					} />
				) : (
					<Redirect from="/admin/cp" to="/admin/login" />
				)}
				<Route path="/admin/cp" render={props => 
					<AdminControlPanel
						handleLogout={this.handleLogout}
						getUser={this.getUser}
						user={this.state.user}
					{...props} />
				} />
			</Switch>
		);
	}
}

export default AdminApp;


// WEBPACK FOOTER //
// ./src/admin-components/AdminApp.js